import React from 'react';

export const TableRowToogle = ({ title, name, checked, onChange }) => (
    <tr> 
        <th>{title}</th>
        <th>
            <div className="switch primary-switch">
                <label onClick={(e) => { e.preventDefault(); onChange({ target: { name, value: !checked }}) }}>
                    <input type="checkbox" checked={checked} />
                    <span className="lever"></span>
                </label>
            </div>
        </th>
    </tr>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/toogle.jsx